import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function sendDeviceCommand(device, newStatus, comment, maintenanceOverride, args) {
  try {
    loginfo();
    return await apiClient.post('/updateConnectedDeviceCommands_v2', {
      device: {
        id: device.id,
        node_id: device.node_id,
        status: Number(newStatus),
        comment: comment,
        maintenanceOverride: maintenanceOverride,
        system_type: device.system_type,
        device_type: device.device_type,
        ...args,
      },
    });
  } catch (error) {
    throw error;
  }
}

export async function sendGroupCommand(group, newStatus, comments, args) {
  try {
    loginfo();
    return await apiClient.post('/updateGroupCommands_v2', {
      groupId: group,
      status: Number(newStatus),
      comments: comments,
      ...args,
    });
  } catch (error) {
    console.error('updateGroupCommands_v2 failed.', error);
  }
}
